export default __webpack_public_path__ + "static/media/NotAvailable.9fcb8293.svg";